/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_Listen_To_PapersInputs */

const en_app_footer_listen_to_papers = /** @type {(inputs: App_Footer_Listen_To_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to Papers`)
};

const es_app_footer_listen_to_papers = /** @type {(inputs: App_Footer_Listen_To_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchar artículos`)
};

/**
* | output |
* | --- |
* | "Listen to Papers" |
*
* @param {App_Footer_Listen_To_PapersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_listen_to_papers = /** @type {((inputs?: App_Footer_Listen_To_PapersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_Listen_To_PapersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_listen_to_papers(inputs)
	return en_app_footer_listen_to_papers(inputs)
});